<div class="dataTable inline-edit-table" [formGroup]="form">
  <table class="row-border hover inline-edit-table__grid">
    <thead>
      <tr>
        <th *ngIf="selectionEnabled" class="inline-edit-table__selection-cell">
          <input
            type="checkbox"
            [checked]="areAllRowsSelected"
            [indeterminate]="isSelectAllIndeterminate"
            (change)="onToggleSelectAll($any($event.target).checked)"
          />
        </th>
        <th *ngFor="let column of columns">{{ column.header }}</th>
      </tr>
    </thead>

    <tbody>
      <tr
        *ngFor="let row of rowsFormArray.controls; let rowIndex = index"
        [formGroup]="rowsFormArray.at(rowIndex)"
      >
        <td *ngIf="selectionEnabled" class="inline-edit-table__selection-cell">
          <input
            type="checkbox"
            [checked]="isRowSelected(rowIndex)"
            (change)="onToggleRow(rowIndex, $any($event.target).checked)"
          />
        </td>
        <td *ngFor="let column of columns">
          @switch (column.editable === false) {
            @case (true) {
              <span class="inline-edit-table__value">{{ data[rowIndex]?.[column.field] }}</span>
            }
            @default {
              @switch (column.controlType) {
                @case (controlType.SingleSelectAutocomplete) {
                  <app-single-select-autocomplete
                    [formControlName]="column.field"
                    [autocompleteOptions]="column.autocompleteOptions || []"
                    [optionLabel]="column.optionLabel || 'name'"
                    [optionValue]="column.optionValue || 'id'"
                  ></app-single-select-autocomplete>
                }
                @case (controlType.SingleSelectAutocompleteWithCreate) {
                  <app-single-select-autocomplete-and-create
                    [formControlName]="column.field"
                    [autocompleteOptions]="column.autocompleteOptions || []"
                    [optionLabel]="column.optionLabel || 'name'"
                    [optionValue]="column.optionValue || 'id'"
                    [createOptionMethod]="column.createOptionMethod"
                    [createErrorKey]="column.createErrorKey || 'validationError'"
                  ></app-single-select-autocomplete-and-create>
                }
                @default {
                  <app-input [formControlName]="column.field" [showErrors]="false"></app-input>
                }
              }
            }
          }
        </td>
      </tr>
    </tbody>
  </table>
</div>
